import { GraphQLClient } from 'graphql-request';

function _createClient() {
  if (!process.env.REACT_APP_SELF_TEST_GQL_ENDPOINT)
    throw Error('No REACT_APP_SELF_TEST_GQL_ENDPOINT');
  return new GraphQLClient(process.env.REACT_APP_SELF_TEST_GQL_ENDPOINT);
}

let _graphqlClient = _createClient();

export const graphqlClient = () => _graphqlClient;

export function doQuery(query: string, variables: any) {
  return graphqlClient().request(query, variables);
}
